import React from 'react';
import { IonButtons, IonButton } from '@ionic/react';

class SaveProjectButton extends React.Component<any, any> {
  render() {
    return (
      <IonButtons slot="end">
        <IonButton onClick={this.props.handler} disabled={! this.props.settings.isValid ? true : false}>
          Spara
        </IonButton>
      </IonButtons>
    );
  }
}

export default SaveProjectButton;
